import Avatar from 'ui/atoms/Avatar/Avatar';
import StudentsGradesDropdownMenu from 'core/modules/components/dropdowns/StudentsGradesDropdownMenu/StudentsGradesDropdownMenu';
import PropTypes from 'prop-types';
import React from 'react';

function MaterialPreviewAssignedUsers({ allStudents }) {
  const [anchorEl, setAnchorEl] = React.useState({});
  const [openDropdown, setOpenDropdown] = React.useState(false);

  function onCloseDropdown() {
    setOpenDropdown(false);
  }

  function onOpenDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
    setOpenDropdown(!openDropdown);
  }

  return (
    <button className="vertical-students-results__avatars-container hover-basic" ref={anchorEl} onClick={onOpenDropdown}>
      <div className={`vertical-students-results__avatars vertical-students-results__avatars--${allStudents.length <= 2 ? allStudents.length : 'more'}`}>
        {allStudents.slice(0, 2).map((item) => (
          <div className="horizontal-students-result__student" key={item.guid}>
            <Avatar image={item.avatar} size="sm" />
          </div>
        ))}

        {allStudents.length > 2 && (
          <div className="vertical-students-results__count-bubble-2">
            <span className="vertical-students-results__count-bubble-text-2">{allStudents.length}</span>
          </div>
        )}
      </div>

      <StudentsGradesDropdownMenu anchorEl={anchorEl} onClose={onCloseDropdown} open={openDropdown} users={allStudents} />
    </button>
  );
}

MaterialPreviewAssignedUsers.propTypes = {
  allStudents: PropTypes.arrayOf(
    PropTypes.shape({
      guid: PropTypes.string.isRequired,
      avatar: PropTypes.string,
    })
  ),
};

MaterialPreviewAssignedUsers.defaultProps = {
  allStudents: [],
};

export default MaterialPreviewAssignedUsers;
